<template>
    <div class="bg-white mt-5 mx-2">
        <div class="inline-block w-full">
            <div class="text-center uppercase text-gray-600 border-b py-2 shadow">{{ title }}</div>
            <div class="flex flex-col">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TitledCardBase",
        props: ['title']
    }
</script>

<style scoped>

</style>